import { patientService } from "./ServiceFactory";
export default patientService;
